export enum ConnectorType {
  NetSuite = 'NetSuite',
}
